import { PLAN_TYPES } from "@/utils";

export const getPlans = (
  state,
  plans
) => {
  const investmentPlans = plans.filter( plan => [PLAN_TYPES.crypto, PLAN_TYPES.invesment].includes(plan.type))
  const savingPlans = plans.filter( plan => plan.type === PLAN_TYPES.savings)
  const loanPlans = plans.filter( plan => plan.type === PLAN_TYPES.loan)
  state.investmentPlans = investmentPlans;
  state.savingPlans = savingPlans; // [...savingPlans, ...investmentPlans];
  state.loanPlans = loanPlans;
};

export const subscribe = (
  state, subscribe
) => {
  state.subscribe = subscribe;
}


const PlanMutation = {
  getPlans,
  subscribe
};

export default PlanMutation;
